import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Home',
            component: () => import(/* webpackChunkName: "home" */'./views/Home.vue'),
            meta: {
                layout: 'default',
                titel: 'Homeseite'
            }
        },
        {
            path: '/home',
            name: 'Home',
            component: () => import(/* webpackChunkName: "home" */'./views/Home.vue'),
            meta: {
                layout: 'default',
                titel: 'Homeseite'
            }
        },
        {
            path: '/antragsformular',
            name: 'AntragsFormular',
            props: true,
            component: () => import('./views/AntragsFormular.vue'),
            meta: {
                layout: 'default',
                titel: 'WMI beantragen'
            }
        },
        {
            path: '/aenderungsformular',
            name: 'AenderungsFormular',
            props: true,
            component: () => import('./views/AenderungsFormular.vue'),
            meta: {
                layout: 'default',
                titel: 'Änderung der Herstellerdaten'
            }
        },
        {
            path: '/uebernahmeformular',
            name: 'UebernahmeFormular',
            props: true,
            component: () => import('./views/UebernahmeFormular.vue'),
            meta: {
                layout: 'default',
                titel: 'WMI Übernahme'
            }
        },
        {
            path: '/dokumentenformular',
            name: 'DokumentenFormular',
            props: true,
            component: () => import('./views/DokumentenFormular.vue'),
            meta: {
                layout: 'default',
                titel: 'Dokumente nachreichen'
            }
        },
        {
            path: '/fehler',
            name: 'Fehler',
            props: true,
            component: () => import(/* webpackChunkName: "fehler" */'./views/Fehler.vue'),
            meta: {
                layout: 'default',
                titel: 'Fehler'
            }
        },
        {
            path: '/wmi_version',
            name: 'WMIVersion',
            component: () => import('./views/WmiVersion.vue'),
            meta: {
                layout: 'default',
                titel: 'WmiVersion'
            }
        },
        {
            path: '/:notFound(.*)',
            name: 'NotFound',
            props: true,
            component: () => import(/* webpackChunkName: "formular3" */'./views/NotFound.vue'),
            meta: {
                layout: 'default',
                titel: 'Not Found'
            }
        }
    ]
})

export default router
